var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"ui-icon",attrs:{"width":"20","height":"20","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.7","stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true"}},[_c('path',{attrs:{"d":_vm.paths[_vm.name] || _vm.paths.grid}})])
}
var staticRenderFns = []

export { render, staticRenderFns }